import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

import { RightOutlined } from '@ant-design/icons';
import styled from '@xstyled/styled-components';
import { Avatar, Card, Layout, Menu, Skeleton, Tooltip } from 'antd';
import { TextLinkButton } from '../../button';
import { styleVariables } from '../../../style';
import { DefaultText } from '../../typography';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Sider = Layout.Sider;
var Meta = Card.Meta;
var StyledTitleMenu = styled(DefaultText)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  a {\n    color: ", ";\n    font-size: 16px;\n    font-weight: 400;\n  }\n"])), styleVariables.colors.gray13);
var StyledBottomTitle = styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  a {\n    font-size: 14px;\n    color: ", ";\n    font-weight: 600;\n  }\n  &:hover {\n    a {\n      color: ", ";\n    }\n  }\n"])), styleVariables.colors.gray10, styleVariables.colors.blue4);
var StyledHiddenSider = styled(Sider)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  transition: 1s ease;\n  max-width: 72px !important;\n  min-width: 72px !important;\n  width: 72px !important;\n  background: ", ";\n"])), styleVariables.colors.gray2);
var CollapseButton = styled(TextLinkButton)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  border: none;\n  height: 25px;\n  width: 25px;\n  border-radius: 50%;\n  box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.3);\n  left: 100%;\n  top: 3rem;\n  transform: translateX(-50%);\n  background-color: ", ";\n  cursor: pointer;\n"])), styleVariables.colors.gray1);
var StyledContentSiderWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  max-width: 100%;\n  min-width: 100%;\n  width: 100%;\n  height: 100%;\n  background: ", ";\n  box-shadow: inset -1px 0px 0px ", ";\n"])), styleVariables.colors.gray1, styleVariables.colors.gray4);
var StyledHiddenMenu = styled(Menu)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  .ant-menu-title-content {\n    margin-left: 0px;\n  }\n  li.ant-menu-item {\n    a:hover {\n      color: ", ";\n    }\n    .ant-image:hover {\n      img {\n        filter: invert(12%) sepia(83%) saturate(5841%) hue-rotate(244deg) brightness(87%)\n          contrast(153%);\n      }\n    }\n  }\n  li.ant-menu-item.ant-menu-item-selected {\n    a {\n      font-style: normal;\n      font-weight: 600;\n      font-size: 16px;\n      color: ", ";\n    }\n    .ant-image {\n      img {\n        filter: invert(12%) sepia(83%) saturate(5841%) hue-rotate(244deg) brightness(87%)\n          contrast(153%);\n      }\n    }\n    ::after {\n      border-right-color: ", ";\n    }\n  }\n"])), styleVariables.colors.blue4, styleVariables.colors.blue4, styleVariables.colors.blue4);
var StyledBottomHiddenMenu = styled(Menu)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  position: absolute;\n  bottom: 0px;\n  li.ant-menu-item {\n    .ant-menu-item-icon {\n      color: ", ";\n    }\n  }\n"])), styleVariables.colors.gray10);
var StyledHiddenCardUser = styled(Card)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  border-bottom: none;\n  .ant-card-body {\n    padding: 24px;\n  }\n"])));
var StyledHiddenMeta = styled(Meta)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  .ant-card-meta-avatar {\n    padding-right: 8px;\n  }\n  .ant-card-meta-detail > div:not(:last-child) {\n    margin-bottom: 0px;\n  }\n  .ant-avatar {\n    background: ", ";\n  }\n"])), styleVariables.colors.gray6);
var StyledAvatar = styled(Avatar)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  background: ", " !important;\n"])), styleVariables.colors.gold1);
export var AppHiddenSidebar = function AppHiddenSidebar(props) {
  var menuItems = props.menuItems,
      translation = props.translation,
      selectedKeys = props.selectedKeys,
      bottomMenuItems = props.bottomMenuItems,
      isLoadingUserInfo = props.isLoadingUserInfo,
      firstLetterOfUsername = props.firstLetterOfUsername,
      navigateToPath = props.navigateToPath,
      handleCollapse = props.handleCollapse,
      urlNavigateAccountSettingPage = props.urlNavigateAccountSettingPage;

  var renderAvatar = function renderAvatar() {
    return isLoadingUserInfo ? /*#__PURE__*/_jsx(Skeleton.Avatar, {
      active: true,
      size: "large"
    }) : /*#__PURE__*/_jsx(StyledHiddenMeta, {
      avatar: /*#__PURE__*/_jsx("a", {
        href: urlNavigateAccountSettingPage,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/_jsx(StyledAvatar, {
          size: "large",
          children: /*#__PURE__*/_jsx("strong", {
            children: firstLetterOfUsername
          })
        })
      })
    });
  };

  var renderRoutingMenuItem = function renderRoutingMenuItem(bottomMenuItem) {
    return bottomMenuItem.path && /*#__PURE__*/_jsx(Tooltip, {
      placement: "right",
      title: translation(bottomMenuItem.title),
      children: /*#__PURE__*/_jsx(StyledBottomTitle, {
        children: navigateToPath === null || navigateToPath === void 0 ? void 0 : navigateToPath(bottomMenuItem.path, bottomMenuItem.icon)
      })
    });
  };

  var renderClickableMenuItem = function renderClickableMenuItem(bottomMenuItem) {
    return bottomMenuItem.onClick && /*#__PURE__*/_jsx(Tooltip, {
      placement: "right",
      title: translation(bottomMenuItem.title),
      children: /*#__PURE__*/_jsx(StyledBottomTitle, {
        onClick: bottomMenuItem.onClick,
        children: bottomMenuItem.icon
      })
    });
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(StyledHiddenSider, {
      trigger: null,
      breakpoint: "lg",
      children: /*#__PURE__*/_jsxs(StyledContentSiderWrapper, {
        children: [/*#__PURE__*/_jsxs(StyledHiddenMenu, {
          mode: "inline",
          selectedKeys: selectedKeys,
          children: [/*#__PURE__*/_jsx(StyledHiddenCardUser, {
            children: renderAvatar()
          }), menuItems && menuItems.map(function (menuItem) {
            return /*#__PURE__*/_jsx(Menu.Item, {
              children: menuItem.path ? /*#__PURE__*/_jsx(Tooltip, {
                placement: "right",
                title: translation(menuItem.title),
                children: /*#__PURE__*/_jsx(StyledTitleMenu, {
                  children: navigateToPath === null || navigateToPath === void 0 ? void 0 : navigateToPath(menuItem.path, menuItem.icon)
                })
              }) : /*#__PURE__*/_jsx(Tooltip, {
                placement: "right",
                title: translation(menuItem.title),
                children: /*#__PURE__*/_jsx("a", {
                  children: menuItem.icon
                })
              })
            }, menuItem.key);
          })]
        }), /*#__PURE__*/_jsx(CollapseButton, {
          onClick: handleCollapse,
          children: /*#__PURE__*/_jsx(RightOutlined, {})
        }), /*#__PURE__*/_jsx(StyledBottomHiddenMenu, {
          mode: "inline",
          selectedKeys: selectedKeys,
          children: bottomMenuItems && bottomMenuItems.map(function (bottomMenuItem) {
            return /*#__PURE__*/_jsxs(Menu.Item, {
              children: [renderRoutingMenuItem(bottomMenuItem), renderClickableMenuItem(bottomMenuItem)]
            }, bottomMenuItem.key);
          })
        })]
      })
    })
  });
};